module.exports = __webpack_public_path__ + "static/img/icon3.1e34c4da.png";